module.exports = __webpack_public_path__ + "img/bg-section-03-mobile.240edc7e.svg";